export const Celebration = ({ secondaryColor = 'none' }: { secondaryColor?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 3H4H2Z" fill="currentColor" opacity="0.5" />
    <path d="M3 2V4V2Z" fill="currentColor" opacity="0.5" />
    <path d="M9.5 2L9 4L9.5 2Z" fill="currentColor" opacity="0.5" />
    <path d="M16 3H18H16Z" fill="currentColor" opacity="0.5" />
    <path d="M17 2V4V2Z" fill="currentColor" />
    <path d="M13 7L12 8L13 7Z" fill="currentColor" opacity="0.5" />
    <path d="M16 11L18 10.5L16 11Z" fill="currentColor" opacity="0.5" />
    <path d="M16 17H18H16Z" fill="currentColor" opacity="0.5" />
    <path d="M17 16V18V16Z" fill="currentColor" opacity="0.5" />
    <path
      d="M12.0001 14.518L5.48209 8L1.09209 17.58C1.00715 17.766 0.981097 17.9735 1.01741 18.1747C1.05371 18.3759 1.15066 18.5613 1.29524 18.7058C1.43982 18.8504 1.62514 18.9474 1.82636 18.9837C2.02758 19.02 2.23509 18.9939 2.42109 18.909L12.0001 14.518Z"
      fill={secondaryColor}
    />
    <path
      d="M2 3H4M3 2V4M9.5 2L9 4M16 3H18M17 2V4M13 7L12 8M16 11L18 10.5M16 17H18M17 16V18M12.0001 14.518L5.48209 8L1.09209 17.58C1.00715 17.766 0.981097 17.9735 1.01741 18.1747C1.05371 18.3759 1.15066 18.5613 1.29524 18.7058C1.43982 18.8504 1.62514 18.9474 1.82636 18.9837C2.02758 19.02 2.23509 18.9939 2.42109 18.909L12.0001 14.518Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
